module.exports = __webpack_public_path__ + "static/kuchnia-photo03_thumb-b838703e0b6f177fab1629ad4bb2cc00.jpg";